import { handleActions } from "redux-actions";

import { authPostError, authPostStart } from "./actions";

export default {
    authError: handleActions(
        {
            [authPostStart]: () => ({
                status: null,
                error: null,
            }),
            [authPostError]: (state, { payload: { status, error } }) => ({
                status,
                error,
            }),
        },
        {
            status: null,
            error: null,
        },
    ),
};
